export default {
  storeSiteList(state, sites) {
    state.sites = sites;
  },
  storeSite(state, site) {
    state.site = site;
  },
  storeUpdatedSite(state, updatedSite) {
    state.site = updatedSite;
  },
  storeCreatedSite(state, createdsite) {
    state.sites << createdsite
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/sites/mutations.js